<template>
  <div>
    <el-tabs v-model="activeName" @tab-click="handleClick" type="border-card">
      <el-tab-pane label="Inventory" name="inventory">

        <el-row :gutter="10">
          <el-col :xs="10" :sm="6" :md="4" :lg="4" :xl="3">
            <div class="grid-content bg-purple">
              <el-date-picker
                class="custom-datepicket"
                v-model="shipmentDate"
                type="date"
                format="dd/MM/yyyy"
                value-format="yyyy-MM-dd"
                placeholder="Pick a day"
                @change="onChangeShipmentDate"
                :picker-options="pickerOptions1"
                >
              </el-date-picker>
            </div>
          </el-col>
          <el-col :xs="14" :sm="6" :md="8" :lg="5" :xl="3">
            <div class="grid-content bg-purple-light">
              <el-select
                style="width:200px margin-right: 10px"
                placeholder="Select MAWB"
                v-model="selects.simple" clearable @change="onChangeMawb">
                <el-option
                  v-for="option in selects.list"
                  :value="option.mawb"
                  :label="`${option.customer ? option.customer+' | ' : ''}${option.vessel && option.vessel+ ' /' } ${option.mawb}`"
                  :key="option.mawb"
                ></el-option>
                  <!-- :label="`${option.vessel && option.vessel+ ' /' } ${option.mawb}`" -->

              </el-select>
            </div>
          </el-col>
          <el-col :xs="8" :sm="4" :md="8" :lg="3" :xl="8">
            <div class="grid-content bg-purple">
              <el-select
                style="width:100px"
                v-model="pagination.perPage"
                placeholder="Per page"
              >
                <el-option
                  v-for="item in pagination.perPageOptions"
                  :key="item"
                  :label="item"
                  :value="item"
                ></el-option>
              </el-select>
            </div>
          </el-col>
          <el-col :xs="12" :sm="4" :md="4" :lg="8" :xl="5">
            <div class="grid-content bg-purple-light">
              <!-- Logging -->
              <el-tooltip
                class="item"
                effect="light"
                :content="`Logging Scan`"
                placement="top"
                v-if="!isCustomer">
                <div class="btn-action">
                  <el-button
                  type="primary"
                  plain
                  style="padding: 4px;font-size: 24px;"
                  icon="el-icon-document"
                  :disabled="selected ? false : true"
                  @click="handleLoggingShow(0, {}, 'modal-logging-scan')">
                  </el-button>
                </div>
              </el-tooltip>

              <!-- Add -->
              <el-tooltip
                class="item"
                effect="light"
                :content="`Add Parcel`"
                placement="bottom"
                v-if="!isCustomer">
                <div class="btn-action">
                  <el-button
                  type="success"
                  plain
                  style="padding: 4px;font-size: 24px;"
                  icon="el-icon-plus"
                  @click="clickNew">
                  </el-button>
                </div>
              </el-tooltip>

              <!--  Refresh -->
              <el-tooltip
                class="item"
                effect="light"
                :content="`Refresh`"
                placement="top">
                <div class="btn-action">
                  <el-button
                  type="warning"
                  plain
                  style="padding: 4px;font-size: 24px;"
                  :disabled="isRefreshLoading"
                  :icon="`${isRefreshLoading ? 'el-icon-loading' : 'el-icon-refresh'}`"
                  @click="refresh()">
                  </el-button>
                </div>
              </el-tooltip>

              <!-- Download CSV -->
              <el-tooltip
                class="item"
                effect="light"
                :content="`Download`"
                placement="bottom">
                <div class="btn-action">
                  <el-button
                  type="info"
                  plain
                  style="padding: 4px;font-size: 24px;"
                  icon="el-icon-download"
                  @click="csvExport()"
                  :disabled="selected ? false : true">
                  </el-button>
                </div>
              </el-tooltip>
              <div class="checkBox">
                <el-checkbox @change="onCheckboxChange()">Image Only</el-checkbox>
              </div>
            </div>
          </el-col>
          <el-col :xs="24" :sm="24" :md="4" :lg="4" :xl="5">
            <div class="grid-content bg-purple-light">
              <el-tooltip
                class="item"
                effect="light"
                :content="`BagRefNo, DeclarationNo, HAWB, Category, ConsignorName, StreetAndNumber, PostCode, Status`"
                placement="top">
                <fg-input
                  class="input-sm"
                  placeholder="Search"
                  v-model="searchQuery"
                  addon-right-icon="nc-icon nc-zoom-split"
                ></fg-input>
              </el-tooltip>
            </div>
        </el-col>
        </el-row>

        <div class="row">
          <div class="col-sm-12 mt-2">
            <el-table
              v-loading="isTableLoading"
              class="table-striped"
              :data="queriedData"
              border
              style="width: 100%">
              <el-table-column
                type="index"
                width="50">
              </el-table-column>
              <el-table-column
                v-for="column in tableColumns"
                :key="column.label"
                :min-width="column.minWidth"
                :prop="column.prop"
                :label="column.label"
                :fixed="column.fixed"
                :class-name="column.className"
              ></el-table-column>
              <el-table-column
                :min-width="150"
                :fixed="false"
                class-name="td-actions text-center"
                label="#"
              >
                <template slot-scope="props">
                  <p-button
                    type="success"
                    size="sm"
                    icon
                    @click="handleShow(props.$index, props.row, 'modal-parcel-detail')"
                  >
                    <i class="el-icon-zoom-in"></i>
                  </p-button>

                  <p-button
                    type="warning"
                    size="sm"
                    icon
                    @click="handleEdit(props.$index, props.row, 'modal-edit-parcel')"
                    v-if="!isCustomer"
                  >
                    <i class="el-icon-edit"></i>
                  </p-button>

                  <p-button
                    type="danger"
                    size="sm"
                    icon
                    @click="showViewer(props.row.hawb)"
                    :disabled="!props.row.images"
                  >
                    <i class="nc-icon nc-image"></i>
                  </p-button>
                  <!-- Viewer -->
                  <viewer :images="props.row.images" class="viewer" :ref="`viewer-${props.row.hawb}`">
                    <img v-for="(src, key) in props.row.images" :src="getGCSURL(props.row.hawb, src.name)" :key="key">
                  </viewer>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-6 pagination-info">
            <p class="category">Showing {{from + 1}} to {{to}} of {{total}} entries</p>
          </div>
          <div class="col-sm-6">
            <p-pagination
              class="pull-right"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="pagination.total"
            ></p-pagination>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="Upload" name="upload" v-if="!isCustomer">
        <FormUpload></FormUpload>
      </el-tab-pane>
      <el-tab-pane label="New Parcel" name="new" v-if="!isCustomer">
        <FormNewParcel></FormNewParcel>
      </el-tab-pane>
      <el-tab-pane label="Info Link" name="infoLink" v-if="!isCustomer">
        <InfoLink></InfoLink>
      </el-tab-pane>
    </el-tabs>

    <ModalShowDetail
      :modals="modals"
      @afterModalShow="modals.notice = false">
      </ModalShowDetail>
    <ModalEditParcel
      :modals="modalsEdit"
      @afterModalShow="modalsEdit.notice = false"
      @afterUpdated="getParcelAllByMAWBID(selected)">
    </ModalEditParcel>
    <ModalLoggingScan
      :header="modalLoggingScan.header"
      :notice="modalLoggingScan.notice"
      :value="modalLoggingScan.data"
      @afterModalShow="modalLoggingScan.notice = false">
    </ModalLoggingScan>
  </div>
</template>

<script>
import Vue from "vue"
import * as _apiMawb from "@/api/mawb"
import * as _apiParcel from "@/api/parcel"
import * as _apiLogging from "@/api/logging"
import axios from "axios"
import { mapGetters } from 'vuex'
import FormNewParcel from "@/components/Dashboard/Views/Inventory/FormNewParcel"
import FormUpload from "@/components/Dashboard/Views/Inventory/FormUpload"
import InfoLink from "@/components/Dashboard/Views/Inventory/InfoLink"
import ModalShowDetail from "@/components/Dashboard/Views/Inventory/ModalShowDetail"
import ModalEditParcel from "@/components/Dashboard/Views/Inventory/ModalEditParcel"
import ModalLoggingScan from "@/components/Dashboard/Views/Inventory/ModalLoggingScan"
import { Card } from
"src/components/UIComponents"
import {
  Table,
  TableColumn,
  Select,
  Option,
  Tabs,
  TabPane,
  Button,
  Tooltip,
  Form,
  FormItem,
  Input,
  Checkbox,
  Notification,
  DatePicker,
  Tag,
  Scrollbar,
  Row,
  Col,
} from "element-ui"
import PPagination from "src/components/UIComponents/Pagination.vue"
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Select)
Vue.use(Option)
Vue.use(Tabs)
Vue.use(TabPane)
Vue.use(Button)
Vue.use(Tooltip)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Input)
Vue.use(Checkbox)
Vue.use(DatePicker)
Vue.use(Tag)
Vue.use(Scrollbar)
Vue.use(Row)
Vue.use(Col)

export default {
  components: {
    PPagination,
    Card,
    Notification,
    FormNewParcel,
    FormUpload,
    InfoLink,
    ModalShowDetail,
    ModalEditParcel,
    ModalLoggingScan
  },
  data() {
    return {
      arrivalsDate: [],
      pickerOptions1: {
        disabledDate: this.disabledDueDate,
      },
      shipmentDate: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().slice(0, 10),
      fileterImage: false,
      isRefreshLoading: false,
      gcsURL: 'https://storage.googleapis.com/e-express-upload/damage/',
      isTableLoading: false,
      modalsEdit: {
        notice: false,
        header: '',
        content: {},
      },
      modals: {
        notice: false,
        header: '',
        content: {},
      },
      activeName: "inventory",
      pagination: {
        perPage: 10,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50, 100],
        total: 0
      },
      searchQuery: "",
      propsToSearch: ["bagRefNo", "declarationNo", "hawb", "category", "consignorName", "streetAndNumber", "postCode", "status"],
      tableColumns: [
        {
          prop: "bagRefNo",
          label: "Bag Ref.",
          minWidth: 150,
          fixed: false,
          className:""
        },
        {
          prop: "declarationNo",
          label: "Declaration No.",
          minWidth: 160,
          fixed: false,
          className:""
        },
        {
          prop: "hawb",
          label: "HAWB",
          minWidth: 140,
          fixed: false,
          className:""
        },
        {
          prop: "category",
          label: "Category",
          minWidth: 120,
          fixed: false,
          className:"text-center"
        },
        {
          prop: "status",
          label: "Status",
          minWidth: 120,
          fixed: false,
          className:"text-center"
        },
      ],
      tableData: [],
      selects: {
        simple: "",
        list: [],
      },
      modalLoggingScan: {
        header: '',
        notice: false,
        data: []
      }
    }
  },
  computed: {
    ...mapGetters({
      currentUser: "$_user/currentUser",
      getSelected: "$_mawb/getSelected"
    }),
    isCustomer () {
      return this.currentUser.role == 'customer'
    },
    pagedData() {
      return this.tableData.slice(this.from, this.to)
    },
    /***
     * Searches through table data and returns a paginated array.
     * Note that this should not be used for table with a lot of data as it might be slow!
     * Do the search and the pagination on the server and display the data retrieved from server instead.
     * @returns {computed.pagedData}
     */
    queriedData() {
      let result

      if (!this.searchQuery && !this.fileterImage) { // false, false
        this.pagination.total = this.tableData.length
        return this.pagedData
      } else if (this.searchQuery && this.fileterImage) { // true, true
        let filtered = this.tableData.filter(row => {
          let isIncluded = false
          for (let key of this.propsToSearch) {
            let rowValue = row[key].toLocaleLowerCase().toString()
            if (rowValue.includes && rowValue.includes(this.searchQuery.toLocaleLowerCase())) {
              isIncluded = true
            }
          }
          return isIncluded
        })

        result = filtered.filter(row => {
          let isIncluded = false
          if (this.fileterImage && row['images']) {
            isIncluded = true
          }
          return isIncluded
        })

      } else if (this.searchQuery && !this.fileterImage) { // true, false
        result = this.tableData.filter(row => {
          let isIncluded = false
          for (let key of this.propsToSearch) {
              let rowValue = row[key].toLocaleLowerCase().toString()
              if (rowValue.includes && rowValue.includes(this.searchQuery.toLocaleLowerCase())) {
                isIncluded = true
              }
          }
          return isIncluded
        })
      } else if (!this.searchQuery && this.fileterImage) { // false, true
        result = this.tableData.filter(row => {
          let isIncluded = false
          for (let key of this.propsToSearch) {
            if (this.fileterImage && row['images']) {
              isIncluded = true
            }
          }
          return isIncluded
        })
      }
      this.pagination.total = result.length
      return result.slice(this.from, this.to)
    },
    to() {
      let highBound = this.from + this.pagination.perPage
      if (this.total < highBound) {
        highBound = this.total
      }
      return highBound
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1)
    },
    total() {
      this.pagination.total = this.tableData.length
      return this.tableData.length
    },
    selected() {
      return this.selects.simple
    }
  },
  watch: {
    getSelected(v) {
      this.shipmentDate = v.shipmentDate || (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().slice(0, 10)
      this.selects.simple = v.mawb || ''
    }
    // shipmentDate (v) {
    //   this.selects.simple = ''
    //   this.tableData = []
    //   if (v) {
    //     this.initialData(v, '')
    //   }
    // },
    // selected: function (v) {
    //   if (!v) {
    //   this.tableData = []
    //     return
    //   }
    //   this.isTableLoading = true
    //   this.getParcelAllByMAWBID(v)
    // }
  },
  created () {
    this.activeName = this.$route.query.tab || 'inventory'
    this.shipmentDate = this.getSelected.shipmentDate
    this.selects.simple = this.getSelected.mawb
    // this.initialData(this.shipmentDate, this.selects.simple)
    this.onChangeMawb(this.selects.simple)
    this.getArrivalsDate()
  },
  mounted () {
  },
  methods: {
    initialData (date, mawbID) {
      this.isRefreshLoading = true
      let _date = this.formatDate(date)
      this.getMAWBByDate(_date)
    },
    getMAWBByDate (date) {
      _apiMawb.getByDate(date)
      .then(res => {
        this.selects.list = res.data
      })
      .catch(error => {
        this.$notify({
            message: error.response.data.message || 'Unsuccessfully',
          type: 'danger'
        })
      })
      .finally(() => {
        this.isRefreshLoading = false
      })
    },
    getParcelAllByMAWBID (v) {
      this.isRefreshLoading = true
      this.isTableLoading = true
      let _tableData = this.tableData
      let _selects = this.selects
      _apiParcel.getAllByMawbID(v)
      .then(response => {
        try {
          _tableData = response.data
        }
        catch(err) {
          console.log(err)
        }
      })
      .catch(error => {
        this.$notify({
          message: error.response.data.message || 'Unsuccessfully',
          type: 'danger'
        })
      })
      .finally(() => {
        this.selects = _selects
        this.tableData = _tableData
        this.isRefreshLoading = false
        this.isTableLoading = false
      })
    },
    refresh () {
      this.getArrivalsDate()
      if (this.selected) {
        this.getMAWBByDate(this.formatDate(this.shipmentDate))
        this.getParcelAllByMAWBID(this.selected)
      } else if (this.shipmentDate) {
          this.initialData(this.shipmentDate, '')
      }
    },
    handleClick(tab, event) {
      this.$router.push({query: {tab: tab.name}})
    },
    handleEdit(index, row, ref) {
      this.modalsEdit.header = row.hawb.toString() || "-"
      this.modalsEdit.notice = true
      this.modalsEdit.content = row
    },
    handleDelete(index, row) {
      let indexToDelete = this.tableData.findIndex(
        tableRow => tableRow.id === row.id
      )
      if (indexToDelete >= 0) {
        this.tableData.splice(indexToDelete, 1)
      }
    },
    handleShow(index, row, ref) {
      this.modals.content = Object.assign({}, row)
      this.modals.header = row.hawb.toString() || "-"
      this.modals.notice = true
    },
    csvExport() {
      try {
        let arrData = [...this.tableData]
        arrData.forEach(function(v){
          delete v.id
          delete v.historyInternalStatus
          delete v.images
          delete v.customerID
          delete v.updatedAt
        })
        var csv = "\ufeff" + this.$papaparse.unparse(arrData);

        var csvData = new Blob([csv], {type: 'text/csv;charset=utf-8;'});
        var csvURL =  null;
        if (navigator.msSaveBlob)
        {
            csvURL = navigator.msSaveBlob(csvData, 'download.csv');
        }
        else
        {
            csvURL = window.URL.createObjectURL(csvData);
        }

        var link = document.createElement('a');
        link.href = csvURL;
        // tempLink.setAttribute('download', 'download.csv');
        // tempLink.click();
        link.setAttribute("download", this.selected + "_" + new Date().toJSON().slice(0,10).replace(/-/g,'') + ".csv")
        link.click()
        // let arrData = [...this.tableData]
        // arrData.forEach(function(v){
        //   delete v.id
        //   delete v.historyInternalStatus
        //   delete v.images
        //   delete v.customerID
        //   delete v.updatedAt
        // })

        // // UpperCase CSV Header
        // for (var key in arrData[0]) {
        //   var temp
        //   if (arrData[0].hasOwnProperty(key)) {
        //     temp = arrData[0][key]
        //     delete arrData[0][key]
        //     arrData[0][key.toUpperCase()] = temp
        //   }
        // }

        // let csvContent = "data:text/csv;charset=utf-8,\ufeff";
        // csvContent += [
        //   Object.keys(arrData[0]).join(","),
        //   ...arrData.map(item => Object.values(item))
        // ].join("\n").replace(/(^\[)|(\]$)/gm, "");

        // const data = encodeURI(csvContent)
        // const link = document.createElement("a")
        // link.setAttribute("href", data)
        // link.setAttribute("download", this.selected + "_" + new Date().toJSON().slice(0,10).replace(/-/g,'') + ".csv")
        // link.click()

      } catch (err) {
        console.log(err)
      }
    },
    showViewer (hawb) {
      this.$refs['viewer-'+hawb].$viewer.show()
    },
    getGCSURL (hawb, imageName) {
      return this.gcsURL + hawb + '/' + imageName
    },
    clickNew() {
      this.activeName = 'new'
      this.$router.push({query: {tab: 'new'}})
    },
    onCheckboxChange () {
      this.fileterImage = !this.fileterImage
    },
    formatDate(date) {
      var d = new Date(date),
          month = '' + (d.getMonth() + 1),
          day = '' + d.getDate(),
          year = d.getFullYear()

      if (month.length < 2) month = '0' + month
      if (day.length < 2) day = '0' + day

      return [day, month, year].join('-')
    },
    disabledDueDate (time){
      return this.arrivalsDate.indexOf(time.getTime()) === -1
    },
    getArrivalsDate () {
      _apiMawb.getArrivalsDate()
      .then(res => {
        let data = res.data
        for(let i = 0; i < res.data.length; i++) {
          this.arrivalsDate.push(new Date(data[i].replace( /(\d{2})-(\d{2})-(\d{4})/, "$2/$1/$3")).getTime())
        }
        // Set Shipment to last arrival date
        if (data.length > 0) {
          this.shipmentDate = data[data.length - 1].replace( /(\d{2})-(\d{2})-(\d{4})/, "$3-$2-$1")
          this.onChangeShipmentDate(this.shipmentDate)
        }
      })
      .catch(error => {
        this.$notify({
            message: 'Unsuccessfully Fetch Arrivals Date',
          type: 'danger'
        })
      })
      .finally(() => {
        this.isRefreshLoading = false
      })
    },
    onChangeShipmentDate (v) {
      this.selects.simple = ''
      this.tableData = []
      if (v) {
        this.$store.dispatch("$_mawb/ON_SELECTED_CHANGE", {
          shipmentDate: v,
          mawb: this.selectedMAWB
        })
        this.initialData(v, '')
      }
    },
    onChangeMawb (v) {
      if (!v) {
        this.tableData = []
        return
      }
      this.$store.dispatch("$_mawb/ON_SELECTED_CHANGE", {
        shipmentDate: this.shipmentDate,
        mawb: v
      })
      this.isTableLoading = true
      this.getParcelAllByMAWBID(v)
    },
    handleLoggingShow(index, row, ref) {
      this.getLoggingByMawbID(this.selects.simple)
      this.modalLoggingScan.header = this.selects.simple
      this.modalLoggingScan.notice = true
    },
    async getLoggingByMawbID (mawbID) {
      try {
        const res = await _apiLogging.getLoggingScanByMawbID(mawbID)
        this.modalLoggingScan.data = res.data
      } catch (err) {
        this.modalLoggingScan.data = []
        console.log(err)
      }
    }
  },
}
</script>
<style lang="scss" scoped>
.btn-action {
  display: inline-block;
  padding: 0px 8px;
  cursor: pointer;
  &:hover {
    color: #5981ee !important;
  }

  @media screen and (max-width: 1024px) {
    display: none;
  }
}

.el-table .td-actions {
  button.btn {
    margin-right: 5px;
  }
}
// .pull-right:nth-child(2) {
  // padding-right: 20px;
  // background: red;
// }
.el-form-item {
    margin-bottom: 0px;
}
.viewer {
  display: none;
}
.checkBox {
  display: inline-block;
  @media screen and (max-width: 1024px) {
    margin: auto;
  }
}
.custom-datepicket {
  width: 100%;
  margin-right: 10px;
}

  // .el-col {
  //   border-radius: 4px;
  // }
  // .bg-purple-dark {
  //   background: #99a9bf;
  // }
  // .bg-purple {
  //   background: #d3dce6;
  // }
  // .bg-purple-light {
  //   background: #e5e9f2;
  // }
  .grid-content {
    border-radius: 4px;
    min-height: 36px;

    @media screen and (max-width: 1024px) {
      padding: 5px 0px;
    }
  }
</style>
